import clsx from 'clsx';
import React from 'react';

import { Button } from '@/components/button/button';
import { Icon } from '@/components/icon/icon';

import styles from './troubleshootingTips.module.scss';

interface TipAction {
  label: string;
  icon: React.ComponentType<any> | null;
  onClick: () => void;
}

export interface Tip {
  title: string;
  description: string;
  actions?: TipAction[];
}

interface TroubleshootingTipsProps {
  tips: Tip[];
  heading?: string;
  className?: string;
}

export function TroubleshootingTips( { tips, heading = 'Next Steps (as needed)', className }: TroubleshootingTipsProps ) {
  return (
    <div className={ clsx( styles.container, className ) }>
      <h4 className={ styles.heading }>{ heading }</h4>
      { tips.map( ( tip, index ) => (
        <div key={ index } className={ styles.tipItem }>
          <div className={ styles.tipNumber }>{ index + 1 }</div>
          <div className={ styles.tipContent }>
            <h5 className={ styles.tipTitle }>{ tip.title }</h5>
            <p className={ styles.tipDescription }>{ tip.description }</p>
          </div>
          { tip.actions && (
            <div className={ styles.tipActions }>
              { tip.actions.map( ( action, actionIndex ) => (
                <Button
                  key={ actionIndex }
                  variant='secondary'
                  size='sm'
                  onClick={ action.onClick }
                  icon={ action.icon ? <Icon icon={ action.icon } /> : undefined }
                >
                  { action.label }
                </Button>
              ) ) }
            </div>
          ) }
        </div>
      ) ) }
    </div>
  );
}
